<template>
  <leave-of-absence type="My Leave of Absence"></leave-of-absence>
</template>

<script>
import LeaveOfAbsence from "./LeaveOfAbsence.vue";
export default {
  components: {
    LeaveOfAbsence,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Leave/MyLeaveOfAbsence.vue